var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40.0001C31.0458 40.0001 40.0001 31.0458 40.0001 20.0001C40.0001 8.95443 31.0458 0.00012207 20.0001 0.00012207C8.95443 0.00012207 0.00012207 8.95443 0.00012207 20.0001C0.00012207 31.0458 8.95443 40.0001 20.0001 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.496 14.7825H23.8793C23.9009 15.0701 23.9132 15.3603 23.9132 15.6521C23.9132 17.5868 23.4296 19.462 22.5865 20.7968C22.3265 21.2086 21.8894 21.79 21.3044 22.1822V14.7825H18.6958V22.1822C18.1108 21.79 17.6737 21.2086 17.4137 20.7968C16.5705 19.462 16.087 17.5868 16.087 15.6521C16.087 15.3603 16.0994 15.07 16.1209 14.7825H13.5042C13.4874 15.0687 13.4783 15.3586 13.4783 15.6521C13.4783 21.0158 16.343 25.2173 20 25.2173C23.657 25.2173 26.5217 21.0158 26.5217 15.6521C26.5219 15.3586 26.5127 15.0687 26.496 14.7825V14.7825Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26095 9.56523H10.8696V11.3044H13.4783V9.56523H16.087V11.3044H18.6956V9.56523H21.3043V11.3044H23.913V9.56523H26.5217V11.3044H29.1303V9.56523H31.739V11.3044H38.0153C34.7806 4.61445 27.9292 0 20.0001 0C12.0709 0 5.21962 4.61445 1.98462 11.3044H8.26095V9.56523Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 28.6957V30.4348H29.1306V28.6957H26.5219V30.4348H23.9132V28.6957H21.3045V30.4348H18.6959V28.6957H16.0872V30.4348H13.4785V28.6957H10.8696V30.4348H8.26095V28.6957H1.98462C5.21962 35.3856 12.0709 40.0001 20.0001 40.0001C27.9293 40.0001 34.7806 35.3856 38.0156 28.6957H31.7392Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.ff09cbbd5a13833a7e316fce2e188fbd.svg";
export { ForwardRef as ReactComponent };